export default __webpack_public_path__ + "static/media/toyota6.5cfa1488.jpg";